(function () {
  var SELECTOR = '[data-scale-on-scroll]';
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  var instances = [];
  var ticking = false;

  function computeTarget(el) {
    if (reduceMotion.matches) return 1;
    var rect = el.getBoundingClientRect();
    var viewportHeight = window.innerHeight || document.documentElement.clientHeight;
    var start = viewportHeight * 0.85;
    var end = viewportHeight * 0.3;
    var progress = (start - rect.top) / (start - end);
    return Math.min(1, Math.max(0, progress));
  }

  function buildInstance(el) {
    if (el.dataset.scaleReady) return;
    el.dataset.scaleReady = 'true';

    var instance = {
      el: el,
      progress: 0,
      target: 0
    };
    instances.push(instance);
    update(instance, true);
  }

  function update(instance, immediate) {
    instance.target = computeTarget(instance.el);
    if (immediate || reduceMotion.matches) {
      instance.progress = instance.target;
    } else {
      instance.progress += (instance.target - instance.progress) * 0.2;
      if (Math.abs(instance.target - instance.progress) < 0.001) {
        instance.progress = instance.target;
      }
    }
    instance.el.style.setProperty('--b2b-progress', instance.progress);
  }

  function loop() {
    instances = instances.filter(function (instance) {
      return instance.el.isConnected;
    });

    var settled = true;
    instances.forEach(function (instance) {
      update(instance, false);
      if (Math.abs(instance.target - instance.progress) > 0.001) settled = false;
    });

    if (!settled) {
      requestAnimationFrame(loop);
    } else {
      ticking = false;
    }
  }

  function requestUpdate() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(loop);
  }

  function init() {
    document.querySelectorAll(SELECTOR).forEach(buildInstance);
    requestUpdate();
  }

  window.addEventListener('scroll', requestUpdate, { passive: true });
  window.addEventListener('resize', requestUpdate);
  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);

  init();
})();
